import { BranchNameType } from '../types.js'
import { DeploymentContainer } from './deployment-container.js'
import * as z from 'zod'

export const deploymentRequestSchema = z.strictObject({
	container: z.instanceof(DeploymentContainer),
	intoBranchName: z.string(),
})

export type DeploymentRequest = z.infer<typeof deploymentRequestSchema>
